import React, {useContext} from 'react';
import {useParams} from 'react-router-dom';
import {Button} from 'react-bootstrap';
import AuditContext from '../Utils/context.js';

export default function Report() {

  const {schedule} = useContext(AuditContext);

  return <p>kosong</p>
}